<script lang="ts" setup generic="T extends string">
  import Calendar from '@vuepic/vue-datepicker'
  import { format, parse } from 'date-fns'

  import { DATE_FORMAT_LITE } from '~/core/constants'

  import '@vuepic/vue-datepicker/dist/main.css'

  const model = defineModel<T>({ required: true })

  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)

  const today = ref(new Date())

  const date = computed({
    get: () => parse(model.value, DATE_FORMAT_LITE, new Date()),
    set: (date) => {
      model.value = format(date, DATE_FORMAT_LITE) as T
    },
  })

</script>

<template>
  <div
    class="c-date-picker"
    :class="{ 'match-desktop': matchDesktop }"
  >
    <p class="title">
      <span>Date</span>
    </p>
    <div class="calendar">
      <Calendar
        v-model="date"
        locale="fr"
        :min-date="today"
        :enable-time-picker="false"
        inline
        auto-apply
        :day-names="['L','M','M','J','V','S','D']"
      />
    </div>
  </div>
</template>

<style scoped>
.c-date-picker {
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1 0 auto;
  flex-direction: column;
  overflow-y: auto;

  .title {
    position: sticky;
    z-index: 2;
    top: 0;
    padding: 1.5em;
    background-color: white;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125em;
      font-weight: bold;
      opacity: 0.4;
    }
  }

  .calendar {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    font-weight: 600;

    --dp-menu-padding: 0;
    --dp-cell-padding: 0;
    --dp-font-size: .875rem;
    --dp-font-family: open-sans, sans-serif;
    --dp-cell-border-radius: 100%;
    --dp-menu-min-width: 250px;
    --dp-cell-size: 30px;

    &:deep(.dp__main){
      justify-content: center;
    }

    &:deep(.dp__today:not(.dp__active_date)){
      border-width: 0;
      background-color: var(--color-secondary);
      color: white;
    }

    &:deep(.dp__theme_light){
      --dp-border-color: transparent;
      --dp-menu-border-color: transparent;
      --dp-primary-color:var(--color-primary);
    }

    :deep(.dp__calendar_header_item){
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      color: var(--color-secondary);
      opacity: .6;
    }
  }

  .c-divider {
    margin: 1.5em;
  }

  .time-slots {
    padding-bottom: 6em;

    .label {
      margin: 0 1.5em;

      span {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 0.875em;
        font-weight: bold;
        opacity: 0.8;
        text-transform: uppercase;
      }
    }

    .slots {
      display: flex;
      flex-direction: column;
      margin: 1.5em;

      .c-buttons-input {
        grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
      }
    }
  }

  .action {
    position: sticky;
    z-index: 1;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 1.25em;
    background-color: white;
    box-shadow: var(--box-shadow-1);

    button {
      padding: 0.5em 0.75em;
      font-size: 1.5em;
    }
  }

  @media screen and (width >= 1024px) {
    .title {
      display: none;
    }

    .action {
      display: none;
    }
  }
}
</style>
